import Vue from 'vue';
import global_mixin from './global_mixins.js'
import '../css/project_gallery.css'
import Waterfall from 'vue-waterfall/lib/waterfall'
import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'
var _ = require('lodash')
import VueGallery from '../components/Gallery.vue'
import { projectGallery } from '../graphql/queries'
var VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: -20,
  force: true,
  cancelable: false,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
var URLSearchParams = require('url-search-params')
let urlParams = new URLSearchParams(window.location.search)

const app = new Vue({
  el: '#app',
  components: {
    Waterfall,
    WaterfallSlot,
    'gallery': VueGallery
  },
  data() {
    return {
      categoryFilter: null,
      subcategoryFilter: null,
      lightboxIndex: null,
      tabIndex: 0,
      lightboxKey: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
      resultsPage: 1,
      resultsPageMax: 1,
      resultsPageSelect: null,
      firstLimit: 12,
      lastLimit: 0,
      paginationDirection: 'forward',
      searchTileAfter: null,
      searchTileBefore: null
    }
  },
  apollo: {
    getProjects: {
      query: projectGallery,
      update: data => data.searchProjects,
      error (error) {
        if (error.name == 'InvariantError') {
          console.log('Invariant error found... wiping local cache!')
          this.clearApolloCache()
        } else {
          console.error(error)
        }
      },
      variables() {
        return {
          first: this.firstLimit,
          /*        last: (this.paginationDirection === 'backwards') ? 12 : undefined,
                    after: (this.searchTileAfter && this.paginationDirection === 'forward') ? this.searchTileAfter : undefined,
                    before: (this.searchTileBefore && this.paginationDirection === 'backwards') ? this.searchTileBefore : undefined,*/
          filter: {
            categoryId: { "wildcard": (this.categoryFilter) ? this.categoryFilter : null },
            subcategory: { "wildcard": (this.subcategoryFilter) ? this.subcategoryFilter : null }
            // commercial: { "wildcard": ((!this.residentialSwitch) ? "?*" : null) },
            // residential: { "wildcard": ((this.residentialSwitch) ? "?*" : null) }
          }
        }
      },
      skip() {
        return !this.cacheLoaded
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading
      },

    }
  },
  methods: {
    previousPage() {
      if (this.resultsPage > 1) {
        this.resultsPage--
          this.reloadData()
        this.$scrollTo('.room-scene-gallery-container')
      }
    },
    nextPage() {
      if (this.resultsPage < this.resultsPageMax) {
        this.resultsPage++
          this.reloadData()
        this.$scrollTo('.room-scene-gallery-container')
      }
    },
    reloadData: _.throttle(async function() {
      try {
        this.isLoading = true
        this.lightboxKey = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
        this.isLoading = false
      }
      catch (error) {
        this.isLoading = false
        this.addAlert('There was an error loading room scene data!', 'danger')
      }
    }, 750),
  },
  computed: {
    roomScenes() {
      let data = []
      if (this.getProjects) {
        for (const element of this.getProjects.edges) {
          data.push({
            'id': this.decodeRelayID(element.node.id),
            'gallery_id': element.node.gallery.id,
            'name': element.node.gallery.pname,
            'firm': element.node.gallery.firm,
            'category': element.node.categoryName,
            'subcategory': element.node.subcategory,
            'lightbox_description': element.node.gallery.pname + ' <br /> Category: ' + element.node.category + ' <br /> Location: ' + element.node.gallery.location + ' <br /> Series in gallery: ' + element.node.seriesInImage + ' <br /> Colors in gallery: ' + element.node.colorsInImage + ' <br /> Shapes in gallery: ' + element.node.shapesInImage,
            'location': element.node.gallery.location,
            'series_in_image': element.node.seriesInImage,
            'colors_in_image': element.node.colorsInImage,
            'shapes_in_image': element.node.shapesInImage,
            'description': element.node.description,
            'waterfall_image': element.node.cardImage,
            'original_image': element.node.largerImage,
            'slider_image': element.node.sliderImage
          })
        }
      }
      return data
    },
    lightboxContent() {
      let data = []
      if (this.getProjects) {
        for (const element of this.getProjects.edges) {
          data.push({
            image: element.node.sliderImage,
            the_description: element.node.description,
            href: element.node.sliderImage,
          })
        }
      }
      return data
    },
    totalScenes() {
      let data = 0
      if (this.getProjects) {
        data = this.getProjects.length
      }
      return data
    }
  },
  created() {
    if (urlParams.has('tab')) {
      // switch (urlParams.get('tab')) {
      //   case 'collection':
      //     this.tabIndex = 0
      //     break
      //   case 'residential':
      //     this.tabIndex = 1
      //     break
      //   case 'commercial':
      //     this.tabIndex = 2
      //     break
      // }
    }
    // this.reloadData()
  },
  mixins: [global_mixin],
  watch: {
    commercialSwitch: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.reloadData()
      }
    },
    resultsPageSelect: function(newValue, oldValue) {
      if (newValue != oldValue && oldValue != null) {
        this.resultsPage = parseInt(newValue)
        this.reloadData()
        this.$scrollTo('.room-scene-gallery-container')
      }
    },
  }
})



// WEBPACK FOOTER //
// ./core/vue/js/project_gallery.js